<mobi-ui-sidenav-major>
    @for (itemLvl1 of sidenavItems(); track itemLvl1.title) {
        <mobi-ui-sidenav-item-major data-test-e2e="sidenav-item-lvl-1">
            <a
                [routerLink]="itemLvl1.routerLink"
                routerLinkActive
                [preserveFragment]="true"
                mobiTealiumTrackLinkOnsite="{{ itemLvl1.title }}"
                trackingLinkAction="click"
                trackingLinkCategory="OnSiteLink - Left Navigation"
                (click)="closeOverlay()"
            >
                @if (itemLvl1.icon) {
                    <mobi-ui-icon-major class="oiv-viewer-sidenav-lv1-icon" [name]="itemLvl1.icon"></mobi-ui-icon-major>
                }
                {{ itemLvl1.title }}</a
            >
            @for (itemLvl2 of itemLvl1?.children; track itemLvl2.title) {
                <mobi-ui-sidenav-item-major
                    data-test-e2e="sidenav-item-lvl-2"
                    [navigateUpOverride]="baseUrlForResponsiveSidenavBackNavigation() + itemLvl1.routerLink"
                >
                    <a
                        [routerLink]="itemLvl2.routerLink"
                        routerLinkActive
                        [preserveFragment]="true"
                        [queryParams]="queryParams()"
                        mobiTealiumTrackLinkOnsite="{{ itemLvl2.title }}"
                        trackingLinkAction="click"
                        trackingLinkCategory="OnSiteLink - Left Navigation"
                        (click)="closeOverlay()"
                        >{{ itemLvl2.title }}</a
                    >
                    @for (itemLvl3 of itemLvl2?.children; track itemLvl3.title) {
                        <mobi-ui-sidenav-item-major data-test-e2e="sidenav-item-lvl-3">
                            <a
                                trackingLinkAction="click"
                                trackingLinkCategory="OnSiteLink - Left Navigation"
                                mobiTealiumTrackLinkOnsite="{{ itemLvl3.title }}"
                                routerLinkActive="is-active"
                                (click)="closeOverlay()"
                                [queryParams]="queryParams()"
                                [routerLink]="[itemLvl3.routerLink]"
                            >
                                {{ itemLvl3.title }}
                            </a>
                        </mobi-ui-sidenav-item-major>
                    }
                </mobi-ui-sidenav-item-major>
            }
        </mobi-ui-sidenav-item-major>
    }
</mobi-ui-sidenav-major>

<oiv-viewer-give-me-more />
